import { Button } from 'antd';
import { useRef, useState, useEffect } from 'react';

interface ExpandableTextProps {
  text: string;
  lineClamp?: number;
}

export function ExpandableText({ text, lineClamp = 2 }: ExpandableTextProps) {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [maxHeight, setMaxHeight] = useState<string>('0px');

  const items = text
    .split('•')
    .map((item) => item.trim())
    .filter((item) => item.length > 0);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const lineHeight = 38;
      const truncatedHeight = lineClamp * lineHeight;
      const fullHeight = el.scrollHeight;

      setIsTruncated(fullHeight > truncatedHeight);
      setMaxHeight(isExpanded ? `${fullHeight}px` : `${truncatedHeight}px`);
    }
  }, [text, isExpanded, lineClamp]);

  return (
    <div>
      <div
        ref={textRef}
        style={{
          overflow: 'hidden',
          transition: 'max-height 0.4s ease',
          maxHeight,
        }}
      >
        <ul
          className='space-y-4'
          style={{ listStyleType: 'disc', paddingLeft: '1.25rem', margin: 0 }}
        >
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      {isTruncated && (
        <div className='flex justify-center'>
          <Button
            onClick={() => setIsExpanded(!isExpanded)}
            className='btn-secondary mt-2 shadow-none'
          >
            {isExpanded ? 'See less info' : 'See more info'}
          </Button>
        </div>
      )}
    </div>
  );
}
